import { createStore } from "vuex";

export default createStore({
  state: {
    drawerState: true,
    userId: '',    
    userName: '',
    userRa: '',
    userUsername: '',
    userSex: '',
    userType: '',
  },
  getters: {
    drawerState: (state) => state.drawerState
  },
  mutations: {
    changeUserId(state, id) {state.userId = id;},
    changeUserName(state, name) {state.userName = name;},
    changeUserRa(state, ra) {state.userRa = ra;},
    changeUserUsername(state, username) {state.userUsername = username;},
    changeUserSex(state, sex) {state.userSex = sex;},
    changeUserType(state, type) {state.userType = type;},
    setDrawerState(state, value) {state.drawerState = value;},
    toggleDrawerState(state) {state.drawerState = !state.drawerState}
  },
  actions: {},
  modules: {},
});
